import type {ReactElement} from 'react';
import React from 'react';
import {BaseTintOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';
import type {RGBA} from '@Utils/color.util';

interface ItemTintOptionProps {
  onClickColorFill(): void;
}

export function ItemTintOption({...props}: ItemTintOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemTint = useGetKeyFromEffectsActiveItem('tint');
  const activeItemTintColor = useGetKeyFromEffectsActiveItem('tintColor');

  if (!activeItem || !(activeItem && 'effects' in activeItem) || activeItemTint === undefined || !activeItemTintColor) {
    throw new Error(`Item doesn't have effects property`);
  }

  const onClickHandler = (): void => {
    void activeItem.updateFromObject({
      effects: {
        tint: !activeItemTint,
      },
    });
  };

  const updateOpacity = (tintOpacity: number, undoable = true): void => {
    const tintColor = activeItemTintColor.slice() as RGBA;
    tintColor[3] = tintOpacity;
    void activeItem.updateFromObject(
      {
        effects: {
          tintColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <BaseTintOption
      label={activeItem.isImage() && activeItem.isDrawing() ? window.i18next.t('pmwjs_color') : window.i18next.t('pmwjs_tint')}
      tintColor={activeItemTintColor}
      tint={activeItemTint}
      tintOpacity={activeItemTintColor[3]}
      onToggleTint={onClickHandler}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
      updateOpacity={updateOpacity}
    />
  );
}
